module.exports = __webpack_public_path__ + "img/GDQ-svarsstapel_100.5d263e9c.gif";